import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthWrapper from '../../../auth/component';
import AuthLogo from '../../../auth/shared/logo/component';
import { userAuthLoginRequestAction } from '../../../../redux/actions/userAuthorization.actions';
import { setT } from 'helpers/translationUtilities';
import { useTranslation } from 'react-i18next';
export default function ViewLogin() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var falseLogin = useSelector(function (state) { return state.userAuthorization.userSession.userSession; });
    var _a = useState(null), name = _a[0], setName = _a[1];
    var _b = useState(null), password = _b[0], setPassword = _b[1];
    var _c = useState(false), loginRequested = _c[0], setLoginRequested = _c[1];
    var t = useTranslation().t;
    function onFieldChange(_a) {
        var target = _a.target;
        if (target.name === 'password') {
            setPassword(target.value);
        }
        else {
            setName(target.value);
        }
    }
    function onSubmit() {
        setLoginRequested(true);
        dispatch(userAuthLoginRequestAction(name, password));
    }
    function handleKeyDown(e) {
        if (e.key === 'Enter')
            onSubmit();
    }
    function redirectToToken() {
        navigate('/token');
    }
    return (React.createElement(AuthWrapper, null,
        React.createElement("div", { className: "token-authentication token-authentication--login clear" },
            React.createElement("div", { className: "token-authentication__wrapper" },
                React.createElement("div", { className: "token-authentication__inner" },
                    React.createElement(AuthLogo, null),
                    falseLogin && loginRequested ? (React.createElement("div", { className: "general-error" }, setT('wrong_username_or_pass'))) : '',
                    React.createElement("div", { className: "token-authentication__text token-authentication__text--small" }, setT('username')),
                    React.createElement("div", { className: "token-authentication__input" },
                        React.createElement("input", { className: "basic-input", placeholder: t('enter_username'), type: "text", name: "name", onChange: onFieldChange, onKeyDown: handleKeyDown })),
                    React.createElement("div", { className: "token-authentication__text token-authentication__text--small" }, setT('password')),
                    React.createElement("div", { className: "token-authentication__input" },
                        React.createElement("input", { className: "basic-input", placeholder: t('enter_password'), type: "password", name: "password", onChange: onFieldChange, onKeyDown: handleKeyDown })),
                    React.createElement("div", { className: "token-authentication__input" },
                        React.createElement("div", { className: "main-button main-button--fullwidth text-align-center", onClick: onSubmit }, setT('play')))),
                React.createElement("div", { className: "token-authentication__bottom" },
                    React.createElement("div", { className: "token-authentication__footer" },
                        setT('have_gamecode'),
                        React.createElement("span", { onClick: redirectToToken }, t('login'))))),
            React.createElement("div", { className: "token-authentication__sideimage" }))));
}
